import { JSResource } from '../js-resource';
export function PreloadableJSResource(loader, opts) {
  const resource = JSResource(loader, opts);
  return Object.assign(resource, {
    preload() {
      const jsModule = resource.getModuleIfRequired();
      if (jsModule != null) {
        return;
      }
      resource.load().catch(() => {});
    }
  });
}